import { Flex, Image, Text } from '@chakra-ui/react'
import { useTranslation } from 'react-i18next'

export const SupportedKnowMore: React.FC = () => {
  const [t] = useTranslation()
  return (
    <Flex flexDirection='column' w='100%'>
      <Flex flexDirection='row' justifyContent='center'>
        <Image src='/assets/images/img-ext-notebook.png' h='227px' />
        <Flex flexDirection='column' w='460px' justifyContent='center'>
          <Text fontFamily='Poppins' fontSize='24px' fontWeight='bold' marginBottom='18px'>
            {t('onboard.success.desktop.thirdSection.secondTitle')}
          </Text>
          <Text fontFamily='Mulish' fontSize='14px' fontWeight='regular'>
            {t('onboard.success.desktop.thirdSection.description')}
          </Text>
        </Flex>
      </Flex>
      <Flex flexDirection='row' justifyContent='center' marginTop='10px'>
        <Flex flexDirection='column' w='450px' paddingRight='66px' justifyContent='center'>
          <Text fontFamily='Poppins' fontSize='24px' fontWeight='bold' marginBottom='18px' textAlign='right'>
            {t('onboard.success.desktop.fourthSection.title')}
          </Text>
          <Text fontFamily='Mulish' fontSize='14px' fontWeight='regular' textAlign='right'>
            {t('onboard.success.desktop.fourthSection.description')}
          </Text>
        </Flex>
        <Image src='/assets/images/img-como-funciona-seguranca.svg' />
      </Flex>
    </Flex>
  )
}

export const EdgecasesKnowMore: React.FC = () => {
  const [t] = useTranslation()
  return (
    <Flex flexDirection='column' w='100%'>
      <Flex bg='backgroundColors.50' w='100%' flexDirection='column' alignItems='center' paddingBottom='40px'>
        <Text fontFamily='Poppins' fontSize='30px' fontWeight='bold' marginTop='32px' marginBottom='35px'>
          {t('onboard.success.desktop.edgecases.common')}
        </Text>
        <Flex flexDirection='row' justifyContent='center'>
          <Image src='/assets/images/img-ext-notebook.png' h='227px' />
          <Flex flexDirection='column' w='460px' justifyContent='center'>
            <Text fontFamily='Poppins' fontSize='24px' fontWeight='bold' marginBottom='18px'>
              {t('onboard.success.desktop.thirdSection.secondTitle')}
            </Text>
            <Text fontFamily='Mulish' fontSize='14px' fontWeight='regular'>
              {t('onboard.success.desktop.thirdSection.description')}
            </Text>
          </Flex>
        </Flex>
        <Flex flexDirection='row' justifyContent='center' marginTop='10px'>
          <Flex flexDirection='column' w='450px' paddingRight='66px' justifyContent='center'>
            <Text fontFamily='Poppins' fontSize='24px' fontWeight='bold' marginBottom='18px' textAlign='right'>
              {t('onboard.success.desktop.fourthSection.title')}
            </Text>
            <Text fontFamily='Mulish' fontSize='14px' fontWeight='regular' textAlign='right'>
              {t('onboard.success.desktop.fourthSection.description')}
            </Text>
          </Flex>
          <Image src='/assets/images/img-como-funciona-seguranca.svg' />
        </Flex>
      </Flex>
    </Flex>
  )
}
